import React from 'react';

interface FormSectionProps {
  number: number;
  title: string;
  children: React.ReactNode;
  isLast?: boolean;
  rightAction?: React.ReactNode; // Optional right-side action (e.g., Edit button)
}

const FormSection: React.FC<FormSectionProps> = ({
  number,
  title,
  children,
  isLast = false,
  rightAction,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        marginTop: number === 1 ? '20px' : '32px',
      }}
    >
      {/* Section Heading */}
      <div
        style={{
          minHeight: '40px',
          borderBottom: isLast ? 'none' : '1px solid var(--border-primary)',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <ol
          style={{
            listStyle: 'decimal',
            margin: 0,
            padding: 0,
            paddingLeft: '27px',
            fontSize: '18px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            lineHeight: '40px',
            flex: 1,
          }}
          start={number}
        >
          <li>
            <span>{title}</span>
          </li>
        </ol>
        {rightAction && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '16px',
            }}
          >
            {rightAction}
          </div>
        )}
      </div>

      {/* Section Content */}
      <div style={{ padding: '0 24px' }}>{children}</div>
    </div>
  );
};

export default FormSection;
